// /customers/:id and /customers/fr/:frId — a pasteable link to a customer. It opens
// the SAME customer popup the rest of the app uses (one customer view, nothing to
// keep in sync). The FR form resolves the FieldRoutes id to the CRM customer first.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomerPopup from "../Profile/CustomerPopup";
import { getOperationalCustomer } from "../../api/operationsCustomersApi";

export default function CustomerRecordRoute({ customerId, frId }) {
  const navigate = useNavigate();
  const [lead, setLead] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setError("");
    setLead(null);
    if (customerId) {
      setLead({ object: "customer", id: customerId });
      return undefined;
    }
    (async () => {
      try {
        const { data } = await getOperationalCustomer(frId);
        if (!alive) return;
        if (data?.crm_customer_id) setLead({ object: "customer", id: data.crm_customer_id });
        else setError(`FieldRoutes customer ${frId} isn't linked to a customer in Abon yet.`);
      } catch (err) {
        if (!alive) return;
        setError(
          err?.response?.status === 404
            ? `No FieldRoutes customer ${frId} in this business.`
            : "Couldn't open this customer. Check your connection and try again."
        );
      }
    })();
    return () => {
      alive = false;
    };
  }, [customerId, frId]);

  const close = () => navigate("/customers/list");

  if (error) {
    return (
      <div className="ct-state" role="alert" style={{ margin: "var(--s-4)" }}>
        {error}{" "}
        <button type="button" className="ct-more" onClick={close}>
          Back to customers
        </button>
      </div>
    );
  }
  if (!lead) return null;
  return <CustomerPopup key={`${lead.id}`} lead={lead} onClose={close} />;
}
